import PropTypes from "prop-types";

export default {
	id: PropTypes.string,
	src: PropTypes.string,
	shouldShowBottom: PropTypes.bool,
	shouldCover: PropTypes.bool,
};
